// extracted by mini-css-extract-plugin
module.exports = {"space":"Notice_space__ZgIxL"};